import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDelete = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.5 2.75a.25.25 0 0 0-.25.25v1.75h5.5V3a.25.25 0 0 0-.25-.25zm6.75 2V3a1.75 1.75 0 0 0-1.75-1.75h-5A1.75 1.75 0 0 0 7.75 3v1.75H3a.75.75 0 0 0 0 1.5h1.32l1.346 13.919a1.75 1.75 0 0 0 1.742 1.581h9.184a1.75 1.75 0 0 0 1.742-1.581L19.681 6.25H21a.75.75 0 0 0 0-1.5zm1.924 1.5H5.826L7.16 20.024a.25.25 0 0 0 .249.226h9.184a.25.25 0 0 0 .249-.226zM10 9.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75m4 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDelete;
